import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import { Table, Row, Col } from 'antd'
import Detail from './Detail'

import EditCollectionPopup from '@components/Popup/EditCollectionPopup'

@inject((store: any) => {
    const { popupStore, collectionsStore, recordsStore, doctorsStore } = store

    return { popupStore, collectionsStore, recordsStore, doctorsStore }
})
@observer
class List extends Component<any> {
    render() {
        const { list, paging, changePage, loading } = this.props.doctorsStore
        const columns = [
            {
                title: 'מזהה',
                key: 'id',
                width: 50,
                align: 'right',
                render: (_, record) => <span>{record.id}</span>
            },
            {
                title: 'שם הרופא',
                key: 'name',
                width: 200,
                align: 'right',
                render: (_, record) =>
                    record.doctorClinics && record.doctorClinics.find(doctor => doctor.is_professor === 1) ? (
                        <span>פרופ' {record.name}</span>
                    ) : (
                        <span>{record.name}</span>
                    )
            },
            {
                title: 'התמחויות',
                key: 'specializations',
                align: 'right',
                width: 200,
                render: (_, record) => (
                    <span>
                        {record.specialization.map((special, index) => (
                            <span key={index}>
                                {special.name}
                                <br />
                            </span>
                        ))}
                    </span>
                )
            },
            {
                title: 'תפקיד',
                key: 'positions',
                align: 'right',
                width: 300,
                render: (_, record) => (
                    <span>
                        {record.positions && record.positions.length
                            ? record.positions.map((position, index) => (
                                  <span key={index}>
                                      {position.company} - {position.name}
                                      <br />
                                  </span>
                              ))
                            : ''}
                    </span>
                )
            },
            {
                title: 'מרפאות',
                key: 'doctorClinics',
                align: 'right',
                width: 400,
                render: (_, record) => (
                    <div>
                        <Detail clinics={record.doctorClinics} />
                    </div>
                )
            }
        ]
        return (
            <Row>
                <Col>
                    <div className="box">
                        <Table
                            className="center-table"
                            style={{ width: '100%' }}
                            rowKey="id"
                            columns={columns}
                            loading={loading}
                            dataSource={list}
                            pagination={{
                                total: paging.total,
                                pageSize: paging.perPage,
                                current: paging.page,
                                onChange: value => changePage(value)
                            }}
                        />
                    </div>
                    <EditCollectionPopup />
                </Col>
            </Row>
        )
    }
}

export default withRouter(List)
